/* Automatically generated by 'build-entry-base.js' */
import AreaCodeSelect from '../../packages/area-code-select';
import NavFooter from '../../packages/nav-footer';
import NavLang from '../../packages/nav-lang';
import Captcha from '../../packages/captcha';
import Qrcode from '../../packages/qrcode';
import yxtOpenData from 'yxt-open-data/es';
import yxtI18n from 'yxt-i18n/es';
import yxtFactor from 'yxt-factor/es';
// TODO
import commonUtil from '../../packages/common-util';
import TitleUtil from '../../packages/title-util';

import * as ApiInstanceAll from '../../packages/api';
import { transformApiParams } from 'yxt-biz-pc/packages/api/configDomain';

const timezone = yxtI18n.timezone;
const Api = ApiInstanceAll.default;
const otherApi = {};
for (var key in ApiInstanceAll) {
  if (key === "default") continue;
  otherApi[key] = ApiInstanceAll[key];
}

timezone.init();

const components = [
  AreaCodeSelect,
  NavFooter,
  NavLang,
  Captcha,
  Qrcode
];

components.forEach(Component => {
  Component.mixins = Component.mixins || [];
  Component.mixins.push({
    created() {
      // 业务组件埋点统计
      // from：组件名
      // aspect：事件发生描述
      // version：组件库版本
      window.YxtFeLog && window.YxtFeLog.track('e_component', {
        properties: {
          from: Component.name,
          aspect: 'load',
          version: '1.18.10'
        }
      });
    }
  });
});

const setStaticCdnUrl = function(Vue) {
  try {
    if (Vue) {
      Vue.prototype.$imagesBaseUrl = (window.feConfig && window.feConfig.common.imagesBaseUrl) || 'https://images.yxt.com/';
      Vue.prototype.$staticBaseUrl = (window.feConfig && window.feConfig.common.staticBaseUrl) || 'https://stc.yxt.com/';
      Vue.prototype.$isChinese = ['zh', 'ha'].includes(commonUtil.getLanguage());
    }
  } catch (e) {
    console.log(e);
  }
};


var installed = false;
const install = function(Vue, config = {}) {
  Api.setConfig(config);
  yxtOpenData.install(Vue, config);

  const options = transformApiParams(config);
  yxtI18n.Api.setConfig(options, options.source, options.domain);
  yxtFactor.install(options);

  if (installed) return;
  installed = true;
  setStaticCdnUrl(Vue);
  components.forEach(component => {
    component.name && Vue.component(component.name, component);
  });
};

/* istanbul ignore if */
if (typeof window !== 'undefined' && window.Vue) {
  window.__hack_yxtbiz_OpenData = yxtOpenData
  window.__hack_yxtbiz_I18n = yxtI18n
  window.__hack_yxtbiz_Factor = yxtFactor
  install(window.Vue);
}
// hack 
// 如果新增字段保持大写开头
export default {
  version: '1.18.10',
  install,
  yxtOpenData,
  yxtI18n,
  commonUtil,
  Api: Object.assign({}, Api, otherApi),
  ...otherApi,
  TitleUtil,
  AreaCodeSelect,
  NavFooter,
  NavLang,
  Captcha,
  Qrcode
};
